import type { ReactNode } from "react";

import type { ContextAction } from "../../popup";
import { ContextActionsMenu } from "../../popup";
import {
  SidebarSectionCloseButton,
  SidebarSectionContainer,
  SidebarSectionContent,
  SidebarSectionDescription,
  SidebarSectionHeader,
  SidebarSectionHeading,
  SidebarSectionTitle,
} from "../sections";
import { useSidebar } from "../SidebarContext";

type Props = {
  heading: ReactNode;
  description: ReactNode;
  contextActions?: ContextAction[];
  contentPadding?: number;
  children: ReactNode;
};

export const PopOutPanel = ({ description, heading, contextActions = [], children, contentPadding = 16 }: Props) => {
  const { popOut } = useSidebar();

  return (
    <SidebarSectionContainer>
      <SidebarSectionHeader data-test="panel-header">
        <SidebarSectionTitle>
          <SidebarSectionCloseButton
            icon="angle-left"
            onClick={popOut.closePanel}
            data-test="close-popout-panel-button"
          />
          <SidebarSectionHeading>{heading}</SidebarSectionHeading>
          {!!contextActions.length && <ContextActionsMenu contextActions={contextActions} />}
        </SidebarSectionTitle>
        <SidebarSectionDescription>{description}</SidebarSectionDescription>
      </SidebarSectionHeader>
      <SidebarSectionContent style={{ padding: contentPadding ?? 0 }} data-test="content-container">
        {children}
      </SidebarSectionContent>
    </SidebarSectionContainer>
  );
};
